<template>
    <div class="page page-data">
        <div class="bg" :style="{'background-position': dis[currentIndex] + 'vw bottom'}">
            <div class="bus">
                <img src="../assets/img/bus.png" alt="">
            </div>
        </div>
        <div class="page-inner" v-if="yearData">
            <div class="main">
                <div class="main-item show" v-if="yearData.import_time">
                    <p><span>{{yearData.import_time[0]}}</span>年<span>{{yearData.import_time[1]}}</span>月<span>{{yearData.import_time[2]}}</span>日</p>
                    <p>你下载了封面新闻</p>
                    <p>当时的情景，你还记得吗</p>
                    <p>这一路走来</p>
                    <p>我们彼此陪伴、彼此温暖</p>
                    <p>带着爱走入了2020年</p>
                </div>
                <div class="main-item" v-if="yearData.first_news_view_date">
                    <p><span>{{yearData.first_news_view_date[0]}}</span>年<span>{{yearData.first_news_view_date[1]}}</span>月<span>{{yearData.first_news_view_date[2]}}</span>日</p>
                    <p>你的封面故事从这里开始</p>
                    <p>今天你第一次打开了封面新闻</p>
                    <div class="has-data" v-if="yearData.first_news_title">
                        <p>我想你可能不记得了</p>
                        <p>2020你看的第一篇新闻是</p>
                        <p><span>《{{yearData.first_news_title}}》</span></p>
                        <p>并在此停留了<span>{{yearData.first_news_duration}}</span>秒</p>
                    </div>
                    <div class="no-data" v-else>
                        <p>你停留在封面新闻里发着呆</p>
                        <p>却没有打开任何内容</p>
                        <p>这一天，你一定有心事吧</p>
                    </div>
                </div>
                <div class="main-item">
                    <div class="has-data" v-if="yearData.first_discuss_date">
                        <p><span>{{yearData.first_discuss_date[0]}}</span>年<span>{{yearData.first_discuss_date[1]}}</span>月<span>{{yearData.first_discuss_date[2]}}</span>日</p>
                        <p>你第一次发表了自己的评论</p>
                        <p>写出了自己的新闻观点</p>
                        <p>真的很棒哦</p>
                    </div>
                    <div class="no-data" v-else>
                        <p><span>2020</span>年</p>
                        <p>你在封面看了很多内容</p>
                        <p>却没有发表任何评论内容</p>
                        <p>那不如把你想说的话</p>
                        <p>留在<span>2021</span>年与封面分享吧</p>
                    </div>
                </div>
                <div class="main-item">
                    <div class="has-data" v-if="yearData.first_share_date">
                        <p><span>{{yearData.first_share_date[0]}}</span>年<span>{{yearData.first_share_date[1]}}</span>月<span>{{yearData.first_share_date[2]}}</span>日</p>
                        <p>今天的你有点不一样哦</p>
                        <p>因为你主动转发了一条新闻到自己的朋友圈</p>
                        <p>我想你一定是被这条内容吸引了</p>
                    </div>
                    <div class="no-data" v-else>
                        <p><span>2020</span>年</p>
                        <p>热爱使用封面的你</p>
                        <p>这一年却忘了分享</p>
                        <p>遇见好的内容</p>
                        <p>要记得分享给朋友们一起看哦</p>
                    </div>
                </div>
                <div class="main-item">
                    <div class="has-data" v-if="yearData.first_live_view_date">
                        <p><span>{{yearData.first_live_view_date[0]}}</span>年<span>{{yearData.first_live_view_date[1]}}</span>月<span>{{yearData.first_live_view_date[2]}}</span>日</p>
                        <p>今天的你似乎心情不错</p>
                        <p>因为你看了一场有意思的直播</p>
                        <p>当时的你</p>
                        <p>应该也是跟着主播的脚步在奔走吧</p>
                    </div>
                    <div class="no-data" v-else>
                        <p><span>2020</span>年</p>
                        <p>封面新闻做了很多有趣的直播内容</p>
                        <p>但你都错过了呢</p>
                        <p>不过没关系</p>
                        <p><span>2021</span>年</p>
                        <p>让我们在封面直播里遇见彼此吧</p>
                    </div>
                </div>
                <div class="main-item">
                    <div class="has-data" v-if="yearData.first_dynamic_create_date">
                        <p><span>{{yearData.first_dynamic_create_date[0]}}</span>年<span>{{yearData.first_dynamic_create_date[1]}}</span>月<span>{{yearData.first_dynamic_create_date[2]}}</span>日</p>
                        <p>你在青蕉社区发了一条动态</p>
                        <p>乐于分享的你</p>
                        <p>要继续坚持分享你的美好哦</p>
                    </div>
                    <div class="no-data" v-else>
                        <p><span>2020</span>年</p>
                        <p>有很多年轻、有趣的人</p>
                        <p>在青蕉社区分享自己的生活、心得</p>
                        <p>但唯独缺少你的身影</p>
                        <p><span>2021</span>年</p>
                        <p>我们在青蕉社区等待你的第一条分享哦</p>
                    </div>
                </div>
                <div class="main-item">
                    <p>说了这么多</p>
                    <p>其实最想说的是</p>
                    <p><span>2020</span></p>
                    <p>遇见你真好</p>
                </div>
            </div>
        </div>
        <div class="arrow-btn" @click="changeData('')">
            <img src="../assets/img/data_arrow.png" alt="">
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'



@Options({
    data () {
        return {
            currentIndex: 0,
            dis: [0, -33, -70, -105, -125, -145, -180]
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'yearData', 'activityData'])
    },
    beforeUnmount () {
        this.currentIndex = 0
        this.changeData(0)
    },
    mounted () {
        this.$common.track(this.aid, 'load', '用户数据页面')
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
        this.activityData && this.$common.pageLoaded()
    },
    methods: {
        changeData (index?: number | string) {
            if (!this.yearData) {
                return
            }
            const items = document.querySelectorAll('.main-item')
            if (this.currentIndex === items.length -1) {
                this.$router.push({
                    path: '/footprint'
                })
                return
            }
            if (index !== 0) {
                this.currentIndex++
            }
            items.forEach((node, idx) => {
                if (this.currentIndex === idx) {
                    node.className = 'main-item show'
                } else if (this.currentIndex - 1 === idx) {
                    node.className = 'main-item hide'
                } else {
                    node.className = 'main-item'
                }
            })
        }
    }
})
export default class Data extends Vue {}
</script>

<style lang="scss">
.page-data {
    font-size: 0;
    min-height: 100%;
    background: #181f25 url('../assets/img/data_bg.jpg') no-repeat center bottom;
    background-size: 100% auto;
    overflow-x: hidden;
    .page-inner {
        position: relative;
        z-index: 1;
        padding: 2.407407rem 0 9.722222rem;
        .main {
            height: 4.722222rem;
            position: relative;
            display: flex;
            align-items: center;
            .main-item {
                width: 100%;
                position: absolute;
                text-align: center;
                display: none;
                padding: 0 .8rem;
                box-sizing: border-box;
                &.show {
                    display: block;
                    animation: backInLeft 1s forwards;
                }
                &.hide {
                    display: block;
                    animation: backOutLeft 1s forwards;
                }
            }
            p {
                font-size: .37037rem;
                color: #fff;
                line-height: 2;
                span {
                    color: #ff3437;
                }
            }
        }
    }
    .arrow-btn {
        cursor: pointer;
        width: 8.796vw;
        position: absolute;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        bottom: 9.444vw;
        animation: arrowbeat 1.2s alternate infinite;
    }
    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 0;
        background: url('../assets/img/data_build.png') no-repeat left bottom;
        background-size: 290.556vw auto;
        transition: background-position 2s ease-in-out;
        .bus {
            position: absolute;
            width: 59.259vw;
            left: 50%;
            transform: translateX(-50%);
            bottom: 28.241vw;
        }
    }
}

@keyframes arrowbeat {
    0% {
        transform: translateX(-50%) scale(1)
    }
    14% {
        transform: translateX(-50%) scale(1.2)
    }
    28% {
        transform: translateX(-50%) scale(1)
    }
    42% {
        transform: translateX(-50%) scale(1.2)
    }
    70% {
        transform: translateX(-50%) scale(1)
    }
}
</style>